








































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import Utils from '@/utils'
import {Action, State} from 'vuex-class'
import {ClientTypeState} from '@/store/modules/clientTypes'
import {
  AppConfig,
  Driver, RegistrationImage,
} from '@/lib/kepler/interfaces'
import {AppConfigState} from '@/store/modules/configuration'

import {ValidationProvider} from 'vee-validate'
import {VTextField, VFlex, VProgressCircular} from 'vuetify/lib'
import ImageCrop from '@/components/ImageCrop.vue'
import {CameraHelperSimple} from '@/lib/CameraHelperSimple'
import BrowserCamera from '@/components/BrowserCamera.vue'
import sdk from '@/lib/kepler/sdk'

// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    BrowserCamera,
    ImageCrop,
    // Dropzone,
    ValidationProvider,
    VTextField,
    VFlex,
    VProgressCircular,
    Btn: Utils.loadComponent('proxy/Btn'),
    Button: Utils.loadComponent('Button'),
    Img: Utils.loadComponent('proxy/Image'),
    Layout: Utils.loadComponent('proxy/Layout'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
  },
  name: 'RegistrationImageComponent',
})
export default class RegistrationImageComponent extends Vue {
  @State('clientTypes') public types!: ClientTypeState
  @State('configuration') public configState!: AppConfigState
  @State('registration') public registrationState!: { [k: string]: any }
  @State((state) => state.profile.language) public profileLang!: string
  @State((state) => state.configuration.appConfig) public appConfig!: AppConfig

  @Action('openDialog') public openDialog: any
  @Action('closeDialog') public closeDialog: any
  @Action('addProfilePicture') public addProfilePicture!: ({}) => Promise<Driver>

  @Prop() public readonly rules!: string
  @Prop() public readonly name!: string
  @Prop() public readonly placeholder!: string
  @Prop() public readonly buttonText!: string
  @Prop() public readonly label!: string
  @Prop({type: Boolean, default: false}) public readonly required!: boolean
  @Prop({type: Object}) public readonly value!: RegistrationImage
  @Prop({type: String, default: () => ''}) public readonly mask!: string

  public step: 'initial' | 'browserCamera' | 'cropper' | 'final' = 'initial'
  public loading: boolean = false

  public result: string | null = null

  protected cannotLoadImage = false

  protected imageUploadResponse = this.value ? this.value : new RegistrationImage()

  protected cameraOptions: CameraOptions = {
    allowEdit: false,
    cameraDirection: 0,
    correctOrientation: true,
    destinationType: 1,
    encodingType: 0,
    mediaType: 0,
    quality: 75,
    saveToPhotoAlbum: false,
    sourceType: 1,
    targetHeight: 1024,
    targetWidth: 1366,
  }

  protected camera: CameraHelperSimple | null = null
  protected browserCameraRatio: number = 0
  protected buttonColor: string = 'accent'

  @Watch('imageUploadResponse', {deep: true})
  public onValueChange(res: RegistrationImage) {
    if (res && res.token) {
      this.$emit('input', res)
    }
  }

  // protected uploadCB = (response: ProfileUploadImageResponse) => {
  //   this.imageUploadResponse.token = response.token
  //   this.imageUploadResponse.url = response.url
  //   const h = this.camera ? this.camera.height : this.cameraOptions.targetHeight
  //   const w = this.camera ? this.camera.width : this.cameraOptions.targetWidth
  //   const r = {...response, height: h, width: w}
  //   console.log('fuck everything i\'m going fishing', r)
  //   this.$emit('input', r)
  // }

  protected initCamera(fallback?: boolean) {
    this.cameraOptions.sourceType = fallback ? 0 : 1
    return new CameraHelperSimple(this.cameraOptions)
  }

  protected get uploaded() {
    return this.imageUploadResponse && this.imageUploadResponse.token && this.imageUploadResponse.url
  }

  protected initialStep() {
    if (device.platform.toLowerCase() !== 'browser') {
      this.fallbackNativeCamera().then(() => {
        this.step = 'cropper'
      }).catch((e) => {
        this.$log(e, 2)
      })
    } else {
      this.step = 'browserCamera'
    }
  }

  protected resetCamera() {
    const empty: RegistrationImage = {token: '', mime: '', url: '', width: 1366, height: 1024}
    this.$emit('input', empty)
    this.imageUploadResponse = empty
    this.cannotLoadImage = false
    this.camera = this.initCamera()
  }

  protected fallbackNativeCamera() {
    return this.initCamera().getPicture().then((r) => {
      this.result = r
    })
  }

  protected retakePicture() {
    this.result = null
    this.initialStep()
  }

  protected mounted() {
    // resume or init logic
    if (!this.camera) {
      this.camera = this.initCamera()
    }
    if (this.value && this.value.token && this.value.url) {
      this.loading = true
      this.result = this.value.url
      this.step = 'final'
      // const camera = this.camera
      // let err: string | number = ''
      // const setDimensionsAndUrl = () => {
      //   // camera.setUrl(this.value.url)
      //   // camera.setSize(this.imageUploadResponse.width, this.imageUploadResponse.height)
      // }
      //   Axios.get(this.value.url)
      //     .then(setDimensionsAndUrl)
      //     .catch((e: any) => {
      //       err = e.response.status
      //       // camera.setUrl('')
      //       this.cannotLoadImage = true
      //     })
    }
  }

  protected uploadPicture(blob?: Blob) {
    const fail = () => {
      this.$log('Image Upload Failed', 2)
      this.step = 'initial'
    }

    if (!blob) {
      fail()
    } else {
      const formData = new FormData()
      formData.append('file', blob)
      sdk.upload(formData).then((r) => {
        const response = r.data
        this.imageUploadResponse = new RegistrationImage()
        this.imageUploadResponse.width = this.cameraOptions.targetWidth || 0
        this.imageUploadResponse.height = this.cameraOptions.targetHeight || 0
        this.imageUploadResponse.token = response.token
        this.imageUploadResponse.url = response.url
        this.step = 'final'
        this.loading = true
        this.$emit('input', this.imageUploadResponse)
      }).catch(fail)
    }
  }

  protected gotBrowserCameraOutput(data: string) {
    this.result = data
    this.step = 'cropper'
  }

  protected onLoadUploadedImage() {
    this.loading = false
  }
}
